// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Run sheet builder — its own route, opened in a new tab. */

.rs-page {
  flex-grow: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* ---------------- header ---------------- */
.rs-head {
  background: #fff;
  border-bottom: 1px solid #e2dcd0;
  padding: 14px 28px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  flex-shrink: 0;
}
.rs-head-main {
  min-width: 0;
}
.rs-title {
  font-size: 26px;
  line-height: 1.1;
  color: #191714;
  margin: 4px 0 0;
  font-weight: 400;
}
.rs-sub {
  font-size: 12.5px;
  color: #6f6a60;
  margin-top: 3px;
}
.rs-head-actions {
  display: flex;
  align-items: center;
  gap: 9px;
  flex-shrink: 0;
}
.rs-head-actions .rf-btn {
  height: 36px;
  border-radius: 9px;
}
.rs-head-actions .rf-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

/* ---------------- body ---------------- */
.rs-body {
  flex-grow: 1;
  min-height: 0;
  padding: 20px 28px;
  display: flex;
  gap: 18px;
}

/* ---------------- route ---------------- */
.rs-route {
  flex-grow: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
}
.rs-route-head {
  display: flex;
  align-items: baseline;
  gap: 12px;
}
.rs-rule {
  flex-grow: 1;
  height: 1px;
  background: #ddd7cb;
}
.rs-window {
  font-size: 12px;
  color: #8b8477;
  white-space: nowrap;
}
.rs-empty {
  border: 1px dashed #ddd7cb;
  border-radius: 11px;
  padding: 28px 20px;
  text-align: center;
  font-size: 13px;
  color: #a29b8d;
  line-height: 1.5;
  text-wrap: pretty;
}

.rs-stop {
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 11px;
  overflow: hidden;
}
.rs-stop.is-dragging {
  opacity: 0.5;
  border-color: var(--rf-brand-lite);
}
.rs-stop-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 15px;
  border-bottom: 1px solid #f0ece3;
}
.rs-grip {
  width: 14px;
  flex-shrink: 0;
  color: #c4bdad;
  font-size: 14px;
  line-height: 1;
  cursor: grab;
}
.rs-stop-n {
  width: 26px;
  height: 26px;
  border-radius: 8px;
  background: #17150f;
  color: var(--rf-brand-bright);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}
.rs-stop-text {
  flex-grow: 1;
  min-width: 0;
}
.rs-stop-dest {
  font-size: 14px;
  font-weight: 600;
  color: #191714;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rs-stop-service {
  font-size: 12px;
  font-weight: 500;
  color: #8b5a1e;
}
.rs-stop-service b {
  font-weight: 700;
}
.rs-stop-address {
  font-size: 12px;
  color: #8b8477;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rs-arrive {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.rs-arrive span {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #8b8477;
  white-space: nowrap;
}
.rs-arrive input {
  width: 66px;
  height: 30px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fdfcfa;
  padding: 0 10px;
  font: 600 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
  outline: none;
}
.rs-arrive input:focus {
  border-color: var(--rf-brand-lite);
  background: #fff;
}
.rs-remove {
  border: none;
  background: none;
  padding: 0;
  font-size: 16px;
  line-height: 1;
  color: #c4bdad;
  cursor: pointer;
  flex-shrink: 0;
}
.rs-remove:hover {
  color: #a8483e;
}

.rs-line {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 9px 15px 9px 46px;
  border-top: 1px solid #f7f4ee;
}
.rs-line:first-of-type {
  border-top: none;
}
.rs-line-accent {
  width: 3px;
  height: 24px;
  border-radius: 2px;
  flex-shrink: 0;
}
.rs-line-text {
  flex-grow: 1;
  min-width: 0;
}
.rs-line-name {
  font-size: 12.5px;
  font-weight: 600;
  color: #191714;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rs-line-order {
  font-size: 11.5px;
  color: #a29b8d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rs-line-qty {
  font-size: 12px;
  color: #4a453c;
  white-space: nowrap;
  flex-shrink: 0;
}
.rs-line-tag {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 5px;
  white-space: nowrap;
  flex-shrink: 0;
}
.rs-line-tag.is-casket {
  color: var(--rf-brand-deep);
  background: #f2e8d3;
}
.rs-line-tag.is-tribute {
  color: var(--rf-accent);
  background: #e2eeec;
}

/* ---------------- rail ---------------- */
.rs-rail {
  width: 392px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.rs-card {
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 12px;
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.rs-card-title {
  font-size: 15px;
  font-weight: 600;
  color: #191714;
}
.rs-rail .rf-label {
  font-size: 11.5px;
  letter-spacing: 0.07em;
}
.rs-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}
.rs-field-row {
  display: flex;
  gap: 10px;
}
/* Vehicle and Depart share the row evenly — flex-basis 0 so the two
   boxes come out the same width whatever the labels are. */
.rs-field-row .rs-field {
  flex: 1 1;
  width: 0;
}
.rs-field input,
.rs-field select {
  width: 100%;
  /* content-box would add the padding and border on top of the 100% and
     push each box past its column — the two row fields overlapped. */
  box-sizing: border-box;
  height: 42px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fdfcfa;
  padding: 0 12px;
  font: 400 14.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
  outline: none;
}
.rs-field input:focus,
.rs-field select:focus {
  border-color: var(--rf-brand-lite);
  background: #fff;
}

.rs-summary {
  background: #17150f;
  border-radius: 12px;
  padding: 18px 20px;
  color: #fff;
}
.rs-summary-label {
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8a8272;
  margin-bottom: 12px;
}
.rs-summary-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-top: 1px solid #2a251c;
  font-size: 13.5px;
}
.rs-summary-row span:first-child {
  color: #b8b1a3;
}
.rs-summary-row span:last-child {
  color: #fff;
  font-weight: 600;
}

.rs-check {
  display: flex;
  gap: 9px;
  align-items: flex-start;
  font-size: 13.5px;
  color: #4a453c;
  line-height: 1.45;
  text-wrap: pretty;
}
.rs-check-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-top: 7px;
  flex-shrink: 0;
}
.rs-check-dot.is-warn {
  background: #b0872f;
}
.rs-check-dot.is-danger {
  background: #a8483e;
}
.rs-check-dot.is-info {
  background: var(--rf-brand-lite);
}

/* ---------------- responsive: tablet ---------------- */
@media (max-width: 1200px) {
  .rs-body {
    flex-direction: column;
  }
  .rs-rail {
    width: 100%;
  }
}

/* ---------------- print: the driver's copy ---------------- */
@media print {
  .rf-sidebar,
  .rf-topbar,
  .rs-head-actions,
  .rs-rail,
  .rs-grip,
  .rs-remove {
    display: none !important;
  }
  .rs-body {
    padding: 0;
  }
  .rs-stop {
    page-break-inside: avoid;
    break-inside: avoid;
  }
}
`, "",{"version":3,"sources":["webpack://./src/run-sheet-builder.css"],"names":[],"mappings":"AAAA,4DAA4D;;AAE5D;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA,4CAA4C;AAC5C;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,eAAe;EACf,cAAc;EACd,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,8DAA8D;EAC9D,cAAc;EACd,aAAa;AACf;AACA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;2DAC2D;AAC3D;EACE,SAAW;EACX,QAAQ;AACV;AACA;;EAEE,WAAW;EACX;qEACmE;EACnE,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gEAAgE;EAChE,cAAc;EACd,aAAa;AACf;AACA;;EAEE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;;AAEA,yDAAyD;AACzD;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;AACF;;AAEA,+DAA+D;AAC/D;EACE;;;;;;IAME,wBAAwB;EAC1B;EACA;IACE,UAAU;EACZ;EACA;IACE,wBAAmB;IAAnB,mBAAmB;EACrB;AACF","sourcesContent":["/* Run sheet builder — its own route, opened in a new tab. */\n\n.rs-page {\n  flex-grow: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ---------------- header ---------------- */\n.rs-head {\n  background: #fff;\n  border-bottom: 1px solid #e2dcd0;\n  padding: 14px 28px;\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  flex-shrink: 0;\n}\n.rs-head-main {\n  min-width: 0;\n}\n.rs-title {\n  font-size: 26px;\n  line-height: 1.1;\n  color: #191714;\n  margin: 4px 0 0;\n  font-weight: 400;\n}\n.rs-sub {\n  font-size: 12.5px;\n  color: #6f6a60;\n  margin-top: 3px;\n}\n.rs-head-actions {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  flex-shrink: 0;\n}\n.rs-head-actions .rf-btn {\n  height: 36px;\n  border-radius: 9px;\n}\n.rs-head-actions .rf-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n/* ---------------- body ---------------- */\n.rs-body {\n  flex-grow: 1;\n  min-height: 0;\n  padding: 20px 28px;\n  display: flex;\n  gap: 18px;\n}\n\n/* ---------------- route ---------------- */\n.rs-route {\n  flex-grow: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  overflow-y: auto;\n}\n.rs-route-head {\n  display: flex;\n  align-items: baseline;\n  gap: 12px;\n}\n.rs-rule {\n  flex-grow: 1;\n  height: 1px;\n  background: #ddd7cb;\n}\n.rs-window {\n  font-size: 12px;\n  color: #8b8477;\n  white-space: nowrap;\n}\n.rs-empty {\n  border: 1px dashed #ddd7cb;\n  border-radius: 11px;\n  padding: 28px 20px;\n  text-align: center;\n  font-size: 13px;\n  color: #a29b8d;\n  line-height: 1.5;\n  text-wrap: pretty;\n}\n\n.rs-stop {\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 11px;\n  overflow: hidden;\n}\n.rs-stop.is-dragging {\n  opacity: 0.5;\n  border-color: var(--rf-brand-lite);\n}\n.rs-stop-head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 15px;\n  border-bottom: 1px solid #f0ece3;\n}\n.rs-grip {\n  width: 14px;\n  flex-shrink: 0;\n  color: #c4bdad;\n  font-size: 14px;\n  line-height: 1;\n  cursor: grab;\n}\n.rs-stop-n {\n  width: 26px;\n  height: 26px;\n  border-radius: 8px;\n  background: #17150f;\n  color: var(--rf-brand-bright);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n.rs-stop-text {\n  flex-grow: 1;\n  min-width: 0;\n}\n.rs-stop-dest {\n  font-size: 14px;\n  font-weight: 600;\n  color: #191714;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rs-stop-service {\n  font-size: 12px;\n  font-weight: 500;\n  color: #8b5a1e;\n}\n.rs-stop-service b {\n  font-weight: 700;\n}\n.rs-stop-address {\n  font-size: 12px;\n  color: #8b8477;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rs-arrive {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n.rs-arrive span {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #8b8477;\n  white-space: nowrap;\n}\n.rs-arrive input {\n  width: 66px;\n  height: 30px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fdfcfa;\n  padding: 0 10px;\n  font: 600 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n  outline: none;\n}\n.rs-arrive input:focus {\n  border-color: var(--rf-brand-lite);\n  background: #fff;\n}\n.rs-remove {\n  border: none;\n  background: none;\n  padding: 0;\n  font-size: 16px;\n  line-height: 1;\n  color: #c4bdad;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.rs-remove:hover {\n  color: #a8483e;\n}\n\n.rs-line {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  padding: 9px 15px 9px 46px;\n  border-top: 1px solid #f7f4ee;\n}\n.rs-line:first-of-type {\n  border-top: none;\n}\n.rs-line-accent {\n  width: 3px;\n  height: 24px;\n  border-radius: 2px;\n  flex-shrink: 0;\n}\n.rs-line-text {\n  flex-grow: 1;\n  min-width: 0;\n}\n.rs-line-name {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #191714;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rs-line-order {\n  font-size: 11.5px;\n  color: #a29b8d;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rs-line-qty {\n  font-size: 12px;\n  color: #4a453c;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.rs-line-tag {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 7px;\n  border-radius: 5px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.rs-line-tag.is-casket {\n  color: var(--rf-brand-deep);\n  background: #f2e8d3;\n}\n.rs-line-tag.is-tribute {\n  color: var(--rf-accent);\n  background: #e2eeec;\n}\n\n/* ---------------- rail ---------------- */\n.rs-rail {\n  width: 392px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.rs-card {\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 12px;\n  padding: 18px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.rs-card-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #191714;\n}\n.rs-rail .rf-label {\n  font-size: 11.5px;\n  letter-spacing: 0.07em;\n}\n.rs-field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 0;\n}\n.rs-field-row {\n  display: flex;\n  gap: 10px;\n}\n/* Vehicle and Depart share the row evenly — flex-basis 0 so the two\n   boxes come out the same width whatever the labels are. */\n.rs-field-row .rs-field {\n  flex: 1 1 0;\n  width: 0;\n}\n.rs-field input,\n.rs-field select {\n  width: 100%;\n  /* content-box would add the padding and border on top of the 100% and\n     push each box past its column — the two row fields overlapped. */\n  box-sizing: border-box;\n  height: 42px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fdfcfa;\n  padding: 0 12px;\n  font: 400 14.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n  outline: none;\n}\n.rs-field input:focus,\n.rs-field select:focus {\n  border-color: var(--rf-brand-lite);\n  background: #fff;\n}\n\n.rs-summary {\n  background: #17150f;\n  border-radius: 12px;\n  padding: 18px 20px;\n  color: #fff;\n}\n.rs-summary-label {\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #8a8272;\n  margin-bottom: 12px;\n}\n.rs-summary-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 0;\n  border-top: 1px solid #2a251c;\n  font-size: 13.5px;\n}\n.rs-summary-row span:first-child {\n  color: #b8b1a3;\n}\n.rs-summary-row span:last-child {\n  color: #fff;\n  font-weight: 600;\n}\n\n.rs-check {\n  display: flex;\n  gap: 9px;\n  align-items: flex-start;\n  font-size: 13.5px;\n  color: #4a453c;\n  line-height: 1.45;\n  text-wrap: pretty;\n}\n.rs-check-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  margin-top: 7px;\n  flex-shrink: 0;\n}\n.rs-check-dot.is-warn {\n  background: #b0872f;\n}\n.rs-check-dot.is-danger {\n  background: #a8483e;\n}\n.rs-check-dot.is-info {\n  background: var(--rf-brand-lite);\n}\n\n/* ---------------- responsive: tablet ---------------- */\n@media (max-width: 1200px) {\n  .rs-body {\n    flex-direction: column;\n  }\n  .rs-rail {\n    width: 100%;\n  }\n}\n\n/* ---------------- print: the driver's copy ---------------- */\n@media print {\n  .rf-sidebar,\n  .rf-topbar,\n  .rs-head-actions,\n  .rs-rail,\n  .rs-grip,\n  .rs-remove {\n    display: none !important;\n  }\n  .rs-body {\n    padding: 0;\n  }\n  .rs-stop {\n    break-inside: avoid;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
